
import Settings from '../../../config/defaultSettings';
export const API_BASE_URL = Settings.API_BASE_URL;
